import { IAirSearchRequest } from "app_locobook/air-search/air-search.component";

export const airSearchFormDefaultValues: IAirSearchRequest = {
    quantity: {
        adult: 1,
        child: 0,
        infant: 0
    },
    segment: [
        {
            begin: null,
            from: '',
            isFromAirport: false,
            to: '',
            isToAirport: false
        },
        {
            begin: null,
            from: '',
            isFromAirport: false,
            to: '',
            isToAirport: false
        }
    ],
    price: {
        plusOrMinus: {
            percentage: 0
          },
        value: 0
    },
    carrier: {
        exclude: [],
        include: [],
        preferred: []
    },
    fareType: null,
    cabin: null,
    maxVias: null,
    flexibility: {
        begin: {
            plusOrMinus: null
        }
    }
};